/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ExportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Params {
  id: string;

/**
 * Export format: EXCEL or PDF
 */
  format: 'EXCEL' | 'PDF';

/**
 * Language code for export labels (hu or en). Defaults to hu.
 */
  lang?: string;
}

export function exportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet(http: HttpClient, rootUrl: string, params: ExportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, exportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.query('format', params.format, {});
    rb.query('lang', params.lang, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

exportPurchase$VndOpenxmlformatsOfficedocumentSpreadsheetmlSheet.PATH = '/purchase/{id}/export';
